import { createTV, type VariantProps } from 'tailwind-variants';

import { twMergeConfig } from './tw-merge';

const tv = createTV({
  twMergeConfig,
});

export { tv, type VariantProps };
